module.exports = __webpack_public_path__ + "media/images/bg_image/img_bg_image_home_agriculture-2688a29b228ff77364599530f8f45c87.png";